import { OnboardingUploader } from 'layouts/applications/documents/components/OnboardingUploader'
import { OnboardingStepContainer } from './OnboardingStepContainer'

export const PaycheckOCR = (props) => {
  return (
    <OnboardingStepContainer {...props}>
      <OnboardingUploader />
    </OnboardingStepContainer>
  )
}
